import {Button} from '@/components/ui/button/Button'
import {Divider} from '@/components/ui/divider/Divider'
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    ModalTitle
} from '@/components/ui/modal-atoms/ModalAtoms'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {Trans, useTranslation} from '@/translations/i18n'
import {UserExtended} from '@/features/users/types'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledAccessProfileConfirmationModalParagraph} from './style'

export const UpdateUserAccessProfileConfirmationModal = ({
    user,
    onClose,
    onConfirm,
    isConfirmPending,
    roleName
}: {
    user: UserExtended
    onClose: () => void
    onConfirm: () => void
    isConfirmPending: boolean
    roleName?: string
}) => {
    const {t} = useTranslation()

    return (
        <>
            <ModalOverlay onClick={onClose} />
            <Modal width="400px">
                {roleName ? (
                    <>
                        <ModalHeader>
                            <ModalTitle>{t('users:enable_access_profile_to_star')}</ModalTitle>
                        </ModalHeader>
                        <Divider direction="horizontal" />
                        <ModalBody>
                            <Flexbox direction="column" gap={2}>
                                <StyledAccessProfileConfirmationModalParagraph>
                                    {t('users:add_access_profile_paragraph_1')}
                                </StyledAccessProfileConfirmationModalParagraph>
                                <ModalTitle>{roleName}</ModalTitle>
                                <StyledAccessProfileConfirmationModalParagraph>
                                    {t('users:add_access_profile_paragraph_2', {value: user.email})}
                                </StyledAccessProfileConfirmationModalParagraph>
                            </Flexbox>
                        </ModalBody>
                        <Divider direction="horizontal" />
                        <ModalFooter>
                            <Button variant="secondary" onClick={onClose} disabled={isConfirmPending}>
                                {t('commons:cancel')}
                            </Button>
                            <Button variant="primaryNeutral" onClick={onConfirm} disabled={isConfirmPending}>
                                {t('commons:confirm')}
                                {isConfirmPending && <Spinner size={14} />}
                            </Button>
                        </ModalFooter>
                    </>
                ) : (
                    <>
                        <ModalHeader>
                            <ModalTitle>{t('users:remove_access_profile_title')}</ModalTitle>
                        </ModalHeader>
                        <Divider direction="horizontal" />
                        <ModalBody>
                            <Flexbox direction="column" gap={4}>
                                <StyledAccessProfileConfirmationModalParagraph>
                                    <Trans
                                        i18nKey="users:remove_access_profile_paragraph_1"
                                        values={{value: user.fullName}}
                                        components={{b: <b />}}
                                    />
                                </StyledAccessProfileConfirmationModalParagraph>
                                <StyledAccessProfileConfirmationModalParagraph>
                                    {t('users:remove_access_profile_paragraph_2')}
                                </StyledAccessProfileConfirmationModalParagraph>
                            </Flexbox>
                        </ModalBody>
                        <Divider direction="horizontal" />
                        <ModalFooter>
                            <Button variant="secondary" onClick={onClose} disabled={isConfirmPending}>
                                {t('commons:cancel')}
                            </Button>
                            <Button variant="primaryNeutral" onClick={onConfirm} disabled={isConfirmPending}>
                                {t('users:remove_access_profile')}
                                {isConfirmPending && <Spinner size={14} />}
                            </Button>
                        </ModalFooter>
                    </>
                )}
            </Modal>
        </>
    )
}
